import React, { useEffect, useRef, useState } from 'react';

const Hero = () => {
  const typedRef = useRef(false);
  const codeTypedRef = useRef(false);
  const [showVideoModal, setShowVideoModal] = useState(false);

  // Add typewriter effect to gradient text
  useEffect(() => {
    if (typedRef.current) return; // Prevent multiple executions
    typedRef.current = true;

    const text = 'With Innovation';
    const element = document.querySelector('.gradient-text');
    if (element) {
      element.textContent = '';
      let index = 0;
      
      const typeWriter = () => {
        if (index < text.length) {
          element.textContent += text.charAt(index);
          index++;
          setTimeout(typeWriter, 100);
        }
      };
      
      setTimeout(typeWriter, 500);
    }
  }, []);

  // Add smooth line-by-line typing effect inside the code editor for future.js
  useEffect(() => {
    if (codeTypedRef.current) return;
    codeTypedRef.current = true;

    const codeArea = document.querySelector('.code-area');
    if (!codeArea) return;

    const lines = [
      "<span class=\"comment\">// Initialize System</span>",
      "<span class=\"keyword\">import</span> { Innovation } <span class=\"keyword\">from</span> <span class=\"string\">'@zentak/core'</span>;",
      "",
      "<span class=\"keyword\">const</span> <span class=\"variable\">system</span> = <span class=\"keyword\">new</span> <span class=\"class\">Innovation</span>();",
      "<span class=\"variable\">system</span>.<span class=\"function\">deploy</span>(<span class=\"string\">'GLOBAL'</span>);"
    ];

    // Clear existing lines for animation intro
    codeArea.innerHTML = '';

    let i = 0;
    const revealNext = () => {
      if (i < lines.length) {
        const div = document.createElement('div');
        div.className = 'code-line';
        div.style.opacity = '0';
        div.style.transform = 'translateY(12px)';
        div.innerHTML = lines[i];
        codeArea.appendChild(div);

        // Smooth reveal
        requestAnimationFrame(() => {
          div.style.transition = 'opacity 400ms ease, transform 400ms ease';
          div.style.opacity = '1';
          div.style.transform = 'translateY(0)';
        });

        i++;
        setTimeout(revealNext, 350);
      } else {
        const cursor = document.createElement('div');
        cursor.className = 'code-line';
        cursor.innerHTML = '<span class="typing-cursor"></span>';
        codeArea.appendChild(cursor);
      }
    };

    // Start animation with a slight delay for premium feel
    setTimeout(revealNext, 400);
  }, []);

  return (
    <section className="hero" id="home">
      <div className="hero-content">
        <div className="hero-text fade-in">
          <h1>Building The Future <span className="gradient-text">With Innovation</span></h1>
          <p>Transform your business with cutting-edge glassmorphic design and powerful software solutions.</p>
          <div className="cta-buttons">
            <a href="#contact" className="glass-btn glass-btn-primary"><span>Start Project</span> →</a>
            <a href="#services" className="glass-btn glass-btn-secondary"><span>Explore Services</span></a>
          </div>
          
          {/* Video Demo Section Removed */}
        </div>
        
        {/* Visual: Code Editor */}
        <div className="hero-visual fade-in">
          <div className="code-editor-glass">
            <div className="editor-header">
               <div className="window-controls">
                 <div className="control-dot red"></div>
                 <div className="control-dot yellow"></div>
                 <div className="control-dot green"></div>
               </div>
               <div className="editor-tabs">
                 <div className="tab active">future.js</div>
                 <div className="tab">styles.css</div>
                 <div className="tab">config.json</div>
               </div>
            </div>
            <div className="editor-body">
                <div className="editor-sidebar">
                  <div className="sidebar-title">Explorer</div>
                  <div className="sidebar-item active">📄 future.js</div>
                  <div className="sidebar-item">🎨 styles.css</div>
                  <div className="sidebar-item">⚙️ config.json</div>
                </div>
                <div className="editor-content">
                    <div className="code-area">
                        {/* FIXED: Comment text properly wrapped in brackets */}
                        <div className="code-line"><span className="comment">{'// Initialize System'}</span></div>
                        <div className="code-line"><span className="keyword">import</span> {'{ Innovation }'} <span className="keyword">from</span> <span className="string">'@zentak/core'</span>;</div>
                        <div className="code-line"> </div>
                        <div className="code-line"><span className="keyword">const</span> <span className="variable">system</span> = <span className="keyword">new</span> <span className="class">Innovation</span>();</div>
                        <div className="code-line"><span className="variable">system</span>.<span className="function">deploy</span>(<span className="string">'GLOBAL'</span>);</div>
                        <div className="code-line"><span className="typing-cursor"></span></div>
                    </div>
                </div>
            </div>
            <div className="editor-footer">
                <div className="status-left">
                    <span className="status-item">main</span>
                </div>
                <div className="status-right">
                    <span className="status-item">JavaScript</span>
                </div>
            </div>
          </div>
        </div>
      </div>

      {/* Video Modal */}
      {showVideoModal && (
        <div className="video-modal-overlay" onClick={() => setShowVideoModal(false)}>
          <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="video-modal-close" onClick={() => setShowVideoModal(false)}>✕</button>
            <iframe 
              width="100%" 
              height="600" 
              src="https://www.youtube.com/embed/dQw4w9WgXcQ?autoplay=1" 
              title="Zentak Solutions Demo" 
              frameBorder="0" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
              allowFullScreen
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default Hero;